const FONT_FAMILY = "Inter";
// const FONT_FAMILY = "monospace";
// const FONT_SIZE = "16pt";
const FONT_SIZE = 16;

export { FONT_FAMILY, FONT_SIZE };